import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {amplitude} from '../../../../services/amplitude';
import marketService from '../../../../services/marketService';
import {selectIsConfigInitialized} from '../../../../state/selectors/global';

const useAmplitudeMarket = () => {
    const isConfigInitialized = useSelector(selectIsConfigInitialized);

    useEffect(() => {
        if (!isConfigInitialized) return;

        const marketName = marketService.getMarketFullName()?.toUpperCase();

        amplitude.setMarket(marketName);
    }, [isConfigInitialized]);
};

export default useAmplitudeMarket;
